var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation'),_vm._v(" "),_c('v-main',[_c('nuxt')],1),_vm._v(" "),_c('disclaimer'),_vm._v(" "),_c('notification'),_vm._v(" "),_c('Dialog'),_vm._v(" "),_c('LoginDialog'),_vm._v(" "),_c('LoginNativeDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }